import { PXInitService } from '@zonar-ui/auth';
export function startupFactory(initService: PXInitService): () => Promise<any> {
  return () => {
    return initService.init();
  };
}
